"use strict";
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const theme_1 = require("../../theme");
const text_component_1 = require("../text/text.component");
const popover_component_1 = require("../popover/popover.component");
const popoverIndicator_component_1 = require("../popover/popoverIndicator.component");
/**
 * Tooltip displays informative text when users focus on or tap an element.
 *
 * @extends React.Component
 *
 * @method {() => void} show - Sets Tooltip visible.
 *
 * @method {() => void} hide - Sets Tooltip invisible.
 *
 * @property {boolean} visible - Determines whether popover is visible or not.
 *
 * @property {string} text - Determines the text of the tooltip
 *
 * @property {(style: StyleType) => ReactElement} icon - Determines icon of the component.
 *
 * @property {StyleProp<TextStyle>} textStyle - Customizes text style.
 *
 * @property {ReactElement} children - Determines the element "above" which popover will be shown.
 *
 * @property {string | PopoverPlacement} placement - Determines the placement of the popover.
 * Can be `left`, `top`, `right`, `bottom`, `left start`, `left end`, `top start`, `top end`, `right start`,
 * `right end`, `bottom start` or `bottom end`.
 * Default is `bottom`.
 * Tip: use one of predefined placements instead of strings, e.g `PopoverPlacements.TOP`
 *
 * @property {boolean} fullWidth - Determines whether content element should have same width as child element.
 *
 * @property {StyleProp<ViewStyle>} backdropStyle - Determines the style of backdrop.
 *
 * @property {() => void} onBackdropPress - Determines component's behavior when the user is
 * tapping on back-drop.
 *
 * @overview-example TooltipSimpleUsage
 *
 * @overview-example TooltipWithIcon
 *
 * @overview-example TooltipStyledBackdrop
 *
 * @overview-example TooltipPlacement
 *
 * @example TooltipWithExternalSourceIcon
 *
 * @example TooltipInlineStyling
 */
class TooltipComponent extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.popoverRef = react_1.default.createRef();
        this.show = () => {
            this.popoverRef.current.show();
        };
        this.hide = () => {
            this.popoverRef.current.hide();
        };
        this.getComponentStyle = (source) => {
            const { indicatorBackgroundColor, iconWidth, iconHeight, iconMarginHorizontal, iconTintColor, textMarginHorizontal, textFontSize, textFontWeight, textLineHeight, textFontFamily, textColor, ...containerParameters } = source;
            return {
                container: containerParameters,
                content: {},
                indicator: {
                    backgroundColor: indicatorBackgroundColor,
                },
                icon: {
                    width: iconWidth,
                    height: iconHeight,
                    marginHorizontal: iconMarginHorizontal,
                    tintColor: iconTintColor,
                },
                text: {
                    marginHorizontal: textMarginHorizontal,
                    fontSize: textFontSize,
                    lineHeight: textLineHeight,
                    fontWeight: textFontWeight,
                    fontFamily: textFontFamily,
                    color: textColor,
                },
            };
        };
        this.renderTextElement = (style) => {
            return (react_1.default.createElement(text_component_1.Text, { key: 1, style: [style, this.props.textStyle] }, this.props.text));
        };
        this.renderIconElement = (style) => {
            const iconElement = this.props.icon(style);
            return react_1.default.cloneElement(iconElement, {
                key: 0,
                style: [style, iconElement.props.style],
            });
        };
        this.renderContentElementChildren = (style) => {
            return [
                this.props.icon && this.renderIconElement(style.icon),
                this.renderTextElement(style.text),
            ];
        };
        this.renderPopoverIndicatorElement = (style) => {
            const { indicator } = this.getComponentStyle(this.props.themedStyle);
            return (react_1.default.createElement(popoverIndicator_component_1.PopoverIndicator, { style: indicator }));
        };
        this.renderPopoverContentElement = (style) => {
            const { content, ...childrenStyle } = style;
            const contentChildren = this.renderContentElementChildren(childrenStyle);
            return (react_1.default.createElement(react_native_1.View, { style: [content, styles.content] }, contentChildren));
        };
    }
    render() {
        const { themedStyle, style, children, ...props } = this.props;
        const { container, indicator, ...componentStyle } = this.getComponentStyle(themedStyle);
        const contentElement = this.renderPopoverContentElement(componentStyle);
        return (react_1.default.createElement(popover_component_1.Popover, Object.assign({}, props, { ref: this.popoverRef, style: [container, style], content: contentElement, indicator: this.renderPopoverIndicatorElement }), children));
    }
}
exports.TooltipComponent = TooltipComponent;
TooltipComponent.styledComponentName = 'Tooltip';
const styles = react_native_1.StyleSheet.create({
    content: {
        flexDirection: 'row',
        justifyContent: 'center',
    },
});
exports.Tooltip = theme_1.styled(TooltipComponent);
//# sourceMappingURL=tooltip.component.js.map